import { useMutation, useQuery, UseQueryResult } from 'react-query'
import {
  formatProductDetailFormDataToObject,
  formatRequirementFormDataToObject,
  getBase64,
  orderProperty,
} from './EditOrder/EditOrder.helper'
import _, { filter, pick, size } from 'lodash'
import { createOrder, orderDetailRef, updateOrderDetail } from './Order.service'
import { useAtom } from 'jotai'
import { orderCompanyIdAtom } from '../jotai/order.jotai'
import { isEmptyValue } from '@/utils/common'
import FormDataLib from 'form-data'
import HttpRequest from '@/config/axios.config'
import {
  getOrderSetting,
  getSequentialOrderPropertiesByEntity,
} from './Order.transform'
import { PBF_QUERY_KEY } from '@/constant/pbf'
import { v4 as uuidv4 } from 'uuid'
import { uploadInspectionTaskPhoto } from '@/screens/QSF/InspectionReport/InSpectionReport.service'
import { dateFormat } from '@/utils/date'
import { DATE_FORMAT } from '@/constant/date'
import { COMPANY_SETTING_AUTO_GENERATE_PROPERTY_VALUE } from '@/constant/user'
import { getCompanySetting } from '@/screens/SystemConfigure/UserManagment/UserManagment.transform'
import { IOrderSequentialProperty } from '@/interface/order.interface'

const orderMock = require('@/mocks/order-new.json')
const {
  GET_ORDER_SETTING,
  GET_COMPANY_SETTING_AUTO_GENERATE_PROP,
  GET_ORDER_SEQUENTIAL_PROPERTY,
} = PBF_QUERY_KEY

export default function useOrder() {
  const data = orderMock

  const {
    isSuccess: isSuccessCreated,
    isLoading: isLoadingCreateOrder,
    isError: isErrorCreate,
    mutate: createNewOrder,
    data: dataCreated,
  } = useMutation(createOrder)

  const {
    isSuccess: isSuccessUpdated,
    isError: isErrorUpdate,
    isLoading: isLoadingUpdateOrder,
    mutate: updateOrder,
    data: dataupdated,
  } = useMutation(updateOrderDetail)

  const payloadTran = ({
    orderDetail,
    mediaId,
    tranformProductDetail,
    autoGenerateData = {},
    tranformRequirement,
    propertyValue,
  }) => {
    const fieldPicture = { id: mediaId ? mediaId : null }
    const exceptFieldData = ['sequential_number'] // TODO: Move to constant
    const prepareAutoGeneratePayload = pick(autoGenerateData, exceptFieldData)

    const payload = {
      orders: {
        is_template: false,
        picture: fieldPicture,
        number: orderDetail.number,
        status: 'active',
        to_be_delivered_date: dateFormat(
          orderDetail.to_be_delivered_date,
          DATE_FORMAT.YYYYMMDD
        ),
        supplier: orderDetail.supplier,
        factory: orderDetail.factory,
        property_value: {
          values: propertyValue,
        },
        product_details: tranformProductDetail,
        requirements: tranformRequirement,
        ...prepareAutoGeneratePayload,
      },
      collaborations: [],
      is_update: false,
    }
    return payload
  }
  const handleUpdateOrder = ({
    orderDetail,
    mediaId,
    tranformProductDetail,
    autoGenerateData,
    tranformRequirement,
    propertyValue,
    id,
  }) => {
    const resPayload = payloadTran({
      orderDetail,
      mediaId,
      tranformProductDetail,
      autoGenerateData,
      tranformRequirement,
      propertyValue,
    })
    updateOrder({ ...resPayload, id })
  }

  const handleCreateNewOrder = ({
    orderDetail,
    mediaId,
    tranformProductDetail,
    autoGenerateData,
    tranformRequirement,
    propertyValue,
  }) => {
    const resPayload = payloadTran({
      orderDetail,
      mediaId,
      tranformProductDetail,
      autoGenerateData,
      tranformRequirement,
      propertyValue,
    })

    createNewOrder(resPayload)
  }

  const modifyCreateOrder = async ({
    productValue,
    orderData,
    orderDetail,
    requirementValue,
    orderDetailForm,
    propertyValue,
    type,
    orderId,
    extraDataPayload,
  }) => {
    const { autoGenerateData = {} } = extraDataPayload
    let tranformProductDetail = formatProductDetailFormDataToObject(
      productValue,
      orderData?.orders?.product_details
    )

    let tranformRequirement = formatRequirementFormDataToObject(
      requirementValue,
      orderData?.orders?.requirements,
      extraDataPayload
    )

    if (type === 'clone') {
      if (_.isEmpty(productValue)) {
        tranformProductDetail = orderDetail?.product_details
      }
      if (_.isEmpty(requirementValue)) {
        tranformRequirement = orderDetail?.requirements
      }
    }

    // Allow media delete picture
    let mediaId = null
    // clone

    if (!_.isEmpty(orderDetailForm.picture)) {
      if (type === 'clone' && orderDetailForm.picture[0]?.url_path) {
        mediaId = await orderProperty(orderDetailForm, null)
      } else {
        // create update
        mediaId = !isEmptyValue(orderDetailForm.picture[0].originFileObj)
          ? await orderProperty(orderDetailForm, null)
          : orderDetail?.picture?.id
      }
    }

    ///Upload files for property type file///
    let newPropertyValue = await uploadPropertyTypeFile(propertyValue)

    if (size(autoGenerateData)) {
      newPropertyValue = filter(
        newPropertyValue,
        (item: any) => !(item?.field in autoGenerateData)
      )
    }

    const newTransformRequirement = {
      ...tranformRequirement,
      information: await uploadPropertyTypeFile(
        tranformRequirement.information
      ),
    }

    if (orderId) {
      handleUpdateOrder({
        id: orderId,
        orderDetail: orderDetailForm,
        mediaId: mediaId,
        tranformProductDetail,
        autoGenerateData,
        tranformRequirement: newTransformRequirement,
        propertyValue: newPropertyValue,
      })
      return
    }
    handleCreateNewOrder({
      orderDetail: orderDetailForm,
      mediaId,
      tranformProductDetail,
      autoGenerateData,
      tranformRequirement: newTransformRequirement,
      propertyValue: newPropertyValue,
    })
  }
  return {
    data,
    modifyCreateOrder,
    isSuccessCreated,
    isLoadingCreateOrder,
    isLoadingUpdateOrder,
    isSuccessUpdated,
    dataCreated,
    dataupdated,
    isErrorCreate,
    isErrorUpdate,
  }
}

export function useGetOrderDetail({ id }) {
  const [, setOrderCompanyId] = useAtom(orderCompanyIdAtom)
  const { data, isFetching, refetch, isFetched }: UseQueryResult | any =
    useQuery(
      ['getOrderDetail'],
      async () => {
        const data = await orderDetailRef(id)
        setOrderCompanyId(data.data.data.company.id)
        return data
      },
      {
        enabled: !!id,
      }
    )

  return { data: data?.data?.data, isFetching, refetch, isFetched }
}

async function uploadPropertyTypeFile(propertyValue) {
  const tmp = []
  for (const item of propertyValue) {
    if (item.data_type == 'file') {
      const formData: any = new FormDataLib()
      const uploadedFile = []
      let newUploadedFiles = null
      if (!isEmptyValue(item?.value)) {
        for (const file of item?.value) {
          if (file.originFileObj) {
            formData.append('files', file.originFileObj)
          } else {
            uploadedFile.push(file)
          }
        }
      }
      if (formData.has('files')) {
        newUploadedFiles = await HttpRequest.post(
          `medias/multiple/orders`,
          formData,
          {
            headers: {
              [`Content-Type`]: `multipart/form-data`,
            },
          }
        )
      }
      tmp.push({
        ...item,
        value: [
          ...uploadedFile,
          ...(!isEmptyValue(newUploadedFiles)
            ? newUploadedFiles?.data?.data
            : []),
        ],
      })
    } else if (item.data_type === 'image') {
      const { value = [] } = item

      if (!size(value)) {
        tmp.push(item)
      } else {
        let imageObj = value[0]
        const { size: fileSize, originFileObj } = imageObj

        if (originFileObj) {
          let data_raw = ''
          const uuidImage = uuidv4()
          data_raw = await getBase64(originFileObj)
          const payload = {
            media_id: uuidImage,
            reference_id: uuidImage,
            table: 'orders',
            name: uuidImage,
            data_raw: data_raw,
            type: originFileObj.type || 'image/jpg',
            size: `${fileSize}`,
          }
          imageObj = await uploadInspectionTaskPhoto(payload)
        }
        // PICK Field to save into json property in database
        const pickFieldImage = pick(imageObj, [
          'media_id',
          'name',
          'type',
          'id',
          'url_path',
          'thumbnail_url_path',
        ])

        item.value = [pickFieldImage]
        tmp.push(item)
      }
    } else {
      tmp.push(item)
    }
  }
  return tmp
}

export function useGetSequentialOrderProperty(
  params: any,
  keys = []
): UseQueryResult<Array<IOrderSequentialProperty>> {
  return useQuery({
    queryKey: [GET_ORDER_SEQUENTIAL_PROPERTY, ...keys],
    queryFn: async () => {
      const actionField = params?.action_field ?? {}
      const companyId = params?.companyId
      const result = await getSequentialOrderPropertiesByEntity({
        actionField,
        companyId,
      })

      return result
    },
  })
}

export function useGetOrderAutoGeneratePropertySetting(): UseQueryResult<any> {
  return useQuery({
    queryKey: [GET_COMPANY_SETTING_AUTO_GENERATE_PROP],
    queryFn: async () => {
      const setting = await getCompanySetting(
        'order',
        COMPANY_SETTING_AUTO_GENERATE_PROPERTY_VALUE,
        ['id', 'value']
      )

      if (!setting) return {}

      return { ...setting.value }
    },
  })
}

export function useGetOrderCompanySetting({ companyId = 'companyId' }) {
  return useQuery(
    [GET_ORDER_SETTING, companyId],
    async () => {
      return await getOrderSetting(companyId ?? '')
    },
    { enabled: !!companyId }
  )
}
